<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>
            <b-container fluid="">
                <form @submit.prevent="actualizar">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                {{ item.nombre_material }}
                            </h3>
                        </div>
                        <div class="col-sm-9 mt-3 mb-3">
                            <label for="" class="form-label">Nombre</label>
                            <input type="text" id="campo_nombre_material_mod" class="form-control form-control-sm"
                                required v-model="nombre_material_mod">
                        </div>
                        <div class="col-sm-3 mt-5 mb-3">
                            <button type="submit" class="btn btn-sm btn-outline-dark btn-block">Actualizar</button>
                        </div>
                    </b-row>
                </form>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'ModalEditar',
        props: ['item'],
        data() {
            return {
                nombre_material_mod: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async actualizar() {
                let f = {
                    api: `materiales/${this.item.documentId}`,
                    formulario: {
                        nombre_material: this.nombre_material_mod.toUpperCase().trim()
                    }
                }

                await this.actualizar_data(f)
                await this.obtener_materiales()
                this.cerrar()
            },
            ...mapActions(['obtener_materiales', 'actualizar_data'])
        },
        mounted() {
            this.nombre_material_mod = this.item.nombre_material
            document.getElementById('campo_nombre_material_mod').focus()
        },
    }
</script>

<style></style>